import React from 'react';
import CookiePolicyButtonForm from './buttons-form';

export const COOKIE_POLICY_GA_EVENT_TITLE = 'Cookie Policy';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-4436
 */
const CookiePolicy = () => {

    /*const [showButtons, setShowButtons] = useState(false);

    useEffect(() => {
        const gdprCountryResult = getHiddenDataString('gdpr-country');
        setShowButtons(gdprCountryResult === 'y');
    }, []);*/

    return (
        <>
            <CookiePolicyButtonForm />

            {/*{
                !showButtons &&
                <CookiePolicyAgreeForm />
            }

            {
                showButtons &&
                <CookiePolicyButtonForm />
            }*/}
        </>
    )
}

export default CookiePolicy;